export function isNonEmpty(value) {
	let isTruthyValue = !!value
	let isValidString = true
	if (typeof value === "string" && value.length <= 0) {
		isValidString = false
	}
	return isTruthyValue && isValidString
}

export function isEmailFormat(email) {
	// Regular expression pattern for email validation
	const emailPattern = /^[a-zA-Z0-9!#$%&'*+\-\/=?^_`{|}~.]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/

	// Return true if the email matches the pattern, otherwise false
	return emailPattern.test(email)
}
